import { URLS } from 'modules/axios'
import useApi from 'composables/useApi'

export function grupoArquivosService() {
  const api = useApi()

  function getGrupoArquivo(id) {
    return api.query(`${URLS.grupoArquivos}${id}`)
  }

  function patchComentario(id, data) {
    return api.mutation(`${URLS.comentarios}${id}/`, 'PATCH', data)
  }

  return {
    getGrupoArquivo,
    ...api,
  }
}
